export default __webpack_public_path__ + "static/media/logo.335841c1.svg";